import { enableLogs, updateAllLoggers, levels } from './shared/logging';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
// Call the element loader before the bootstrapModule/bootstrapApplication call
defineCustomElements(window);

if (environment.production) {
  enableProdMode();
  updateAllLoggers(levels.SILENT);
}
else {
  updateAllLoggers(levels.TRACE);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(ref => {
    (window as any).enableDebugMode = ()=> {
      enableLogs();
    }
  })
  .catch(err => console.log(err));
